<div *ngIf="store.rebalancing">
  <div class="border-2 border-gray-800 rounded p-2 bg-gray-900">
    <div class="px-2 flex">
      <div class="w-1/2 pr-4 flex justify-between">
        <span class="text-gray-400"
          >{{ 'rebalancing.baseValue' | translate }}:</span
        >
        <span class="text-gray-400">{{
          store.rebalancing.baseValueInUsd | currency
        }}</span>
      </div>
      <div class="w-1/2 pl-4 flex justify-between">
        <span class="text-gray-400"
          >{{ 'rebalancing.estimatedTargetValue' | translate }}:</span
        >
        <span class="text-gray-400">{{
          store.rebalancing.estimatedTargetValueInUsd | currency
        }}</span>
      </div>
    </div>
    <div class="my-2 border border-gray-800 opacity-50"></div>
    <div class="px-2 flex">
      <div class="w-1/2 pr-4 flex justify-between">
        <span class="text-gray-400"
          >{{ 'rebalancing.sellValue' | translate }}:</span
        >
        <span class="text-gray-400">{{
          store.rebalancing.sellValueInUsd | currency
        }}</span>
      </div>
      <div class="w-1/2 pl-4 flex justify-between">
        <span class="text-gray-400"
          >{{ 'rebalancing.estimatedReceiveValue' | translate }}:</span
        >
        <div>
          <span
            class="ml-1 text-xs text-gray-500 whitespace-nowrap"
            [class.text-red-500]="store.rebalancing.estimatedImpact > 0.01"
            [class.text-green-500]="store.rebalancing.estimatedImpact < 0"
          >
            ({{ -store.rebalancing.estimatedImpact | percent: '0.2-2' }})
          </span>
          <span class="text-gray-400">{{
            store.rebalancing.estimatedReceiveValueInUsd | currency
          }}</span>
        </div>
      </div>
    </div>
    <div class="my-2 border border-gray-800 opacity-50"></div>
    <div class="px-2 flex">
      <div class="w-1/2"></div>
      <div class="w-1/2 pl-4 flex justify-between">
        <span class="text-gray-400"
          >{{ 'rebalancing.minReceiveValue' | translate }}:</span
        >
        <div>
          <span
            class="ml-1 text-xs text-gray-500 whitespace-nowrap"
            [class.text-red-500]="store.rebalancing.maxImpact > 0.01"
            [class.text-green-500]="store.rebalancing.maxImpact < 0"
          >
            ({{ -store.rebalancing.maxImpact | percent: '0.2-2' }})
          </span>
          <span class="text-gray-400">{{
            store.rebalancing.minReceiveValueInUsd | currency
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-2 border-2 border-gray-800 rounded p-2 bg-gray-900">
    <div class="px-2 flex">
      <div class="w-1/2"></div>
      <div class="w-1/2 pl-4 flex justify-between">
        <span class="text-gray-400"
          >{{ 'rebalancing.estimatedGasFees' | translate }}:</span
        >
        <div>
          <span
            *ngIf="assetRepostory.store.getValue().nativeAsset?.token"
            class="text-gray-400"
            >{{
              store.rebalancing.estimatedGasFees
                | assetUnit
                  : assetRepostory.store.getValue().nativeAsset?.token
                      ?.decimals!
                  : assetRepostory.store.getValue().nativeAsset?.token?.symbol!
            }}
          </span>
          <span class="ml-2 text-gray-400"
            >(
            <span
              *ngIf="
                store.rebalancing.estimatedGasFeesInUsd >= 0.01;
                else lessThanOneCent
              "
              class="text-gray-400"
            >
              ≈{{ store.rebalancing.estimatedGasFeesInUsd | currency }}
            </span>
            )</span
          >
        </div>
      </div>
    </div>

    <div class="my-2 border border-gray-800 opacity-50"></div>

    <div class="px-2 flex">
      <div class="w-1/2"></div>
      <div class="w-1/2 pl-4 flex justify-between">
        <span class="text-gray-400"
          >{{ 'rebalancing.estimatedProtocolFees' | translate }}:</span
        >
        <span
          *ngIf="
            store.rebalancing.estimatedProtocolFeesInUsd >= 0.01;
            else lessThanOneCent
          "
          class="text-gray-400"
          >{{ store.rebalancing.estimatedProtocolFeesInUsd | currency }}</span
        >
      </div>
    </div>
  </div>
</div>
<ng-template #lessThanOneCent>
  <span class="text-gray-400"> < $0.01 </span>
</ng-template>
